import { createAction } from 'redux-actions'

export * from './drawing'
export * from './rotatePage'
export * from './zooming'

export const resetState = createAction('RESET_PLAYER_TOOLBAR_STATE')
